<template>
  <div>
    <admin-wrapper
      :straight-title="additionalModuleName"
      :module-enabler="moduleEnabler"
      :inputs="inputs"
      :has-buttons="false"
      :is-form-fetched="isFormFetched"
    >
      <template #table.input>
        <external-systems-table
          :inputs="externalSystemInputs"
          :external-systems="externalSystems"
          :available-systems="availableSystems"
          :init-gets="initGets"
          :delete-connection="deleteConnection"
          :edit-connection="editConnection"
          :add-connection="addConnection"
        />
      </template>
    </admin-wrapper>
  </div>
</template>

<script>
import AdminWrapper from '@/components/AdminWrapper';
import ExternalSystemsTable from '@/components/ExternalSystemsTable';
import { call, get } from 'vuex-pathify';
export default {
  name: 'ExternalSystemsSettings',
  components: { ExternalSystemsTable, AdminWrapper },
  data: () => ({
    isFormFetched: false,
  }),
  computed: {
    additionalModuleName: get('admin/additionalModules@EXTERNAL_SYSTEMS.verbose_name'),
    externalSystems: get('externalSystems/externalSystems'),
    availableSystems: get('externalSystems/availableSystems'),
    isModuleEnabled: get('admin/settingsValues@external_systems_module_enabled'),
    externalSystemInputs() {
      return [
        'name',
        'system',
        'host',
        'port',
        'username',
        'password',
        'dbname',
        'schema_name',
        'table_name',
        'system_id',
        'datasource',
        'attribute_id',
      ];
    },
    inputs() {
      return [
        {
          name: 'table',
          hasSuffix: false,
          isCustom: true,
          isNamedSlot: false,
        },
      ];
    },
    moduleEnabler() {
      return {
        name: 'external_systems_module_enabled',
        straightText: this.additionalModuleName,
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.additionalModuleName }),
      };
    },
  },
  methods: {
    getExternalSystems: call('externalSystems/getExternalSystems'),
    getAvailableSystems: call('externalSystems/getAvailableSystems'),
    deleteConnection: call('externalSystems/deleteConnection'),
    addConnection: call('externalSystems/addConnection'),
    editConnection: call('externalSystems/editConnection'),
    getDataSources: call('layers/getLayersMetadata'),
    async init() {
      await Promise.all([this.getDataSources({ with_attributes_schema: true })]);
      this.isFormFetched = true;
    },
    async initGets() {
      await this.getExternalSystems();
      await this.getAvailableSystems();
    },
  },
  watch: {
    isModuleEnabled(nV) {
      if (nV) {
        this.isFormFetched = false;
        this.init();
      }
    },
  },
  created() {
    if (this.isModuleEnabled) {
      this.init();
    } else {
      this.isFormFetched = true;
    }
  },
};
</script>

<style scoped></style>
